/* Klivlo — hanging toiletry bag PDP + cart drawer (vanilla JS, Shopify Ajax Cart API). Labels come from Liquid/locales. */
(() => {
  // Several sections include this file; run it only once so handlers aren't registered twice
  if (window.TbCart) return;
  const SECTION = 'tb-cart-drawer';
  const RESERVE_KEY = 'tbReserveEnd';
  const $ = (s, r = document) => r.querySelector(s), $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const root = () => (window.Shopify && Shopify.routes ? Shopify.routes.root : '/');
  const drawer = () => document.getElementById('TbCartDrawer');
  const pad = n => String(n).padStart(2, '0');
  const store = { get: k => { try { return localStorage.getItem(k); } catch (_) { return null; } }, set: (k, v) => { try { localStorage.setItem(k, v); } catch (_) {} } };

  // ---------- Dates & timers ----------
  const json = $('[data-tb-json]');
  const cfg = json ? JSON.parse(json.textContent) : {};
  const dateLocale = cfg.dateLocale || document.documentElement.lang || 'fr-FR';
  const addBusinessDays = (date, n) => { const d = new Date(date); while (n > 0) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w !== 0 && w !== 6) n--; } return d; };
  const fmtDay = d => d.toLocaleDateString(dateLocale, { weekday: 'short', day: 'numeric', month: 'short' });
  function paintDates() {
    const now = new Date(), from = fmtDay(addBusinessDays(now, cfg.etaMin || 6)), to = fmtDay(addBusinessDays(now, cfg.etaMax || 10));
    $$('[data-tb-from]').forEach(e => (e.textContent = from));
    $$('[data-tb-to]').forEach(e => (e.textContent = to));
  }
  function tick() {
    const d = new Date(), end = new Date(d); end.setHours(24, 0, 0, 0);
    const left = Math.max(0, Math.floor((end - d) / 1000));
    const h = pad(Math.floor(left / 3600)), m = pad(Math.floor((left % 3600) / 60)), s = pad(left % 60);
    $$('[data-tb-cd-h]').forEach(e => (e.textContent = h));
    $$('[data-tb-cd-m]').forEach(e => (e.textContent = m));
    $$('[data-tb-cd-s]').forEach(e => (e.textContent = s));
    $$('[data-tb-cd-inline]').forEach(e => (e.textContent = `${h}:${m}:${s}`));
    const endR = +store.get(RESERVE_KEY) || 0;
    const r = endR ? Math.max(0, Math.floor((endR - Date.now()) / 1000)) : 300;
    $$('[data-tb-reserve]').forEach(e => (e.textContent = `${pad(Math.floor(r / 60))}:${pad(r % 60)}`));
  }
  function startReservation() {
    const endR = +store.get(RESERVE_KEY) || 0;
    if (!endR || endR <= Date.now()) store.set(RESERVE_KEY, String(Date.now() + 5 * 60 * 1000));
  }

  // ---------- Cart drawer ----------
  async function cartPost(path, body) {
    const d = drawer(); d && d.classList.add('is-busy');
    try {
      const res = await fetch(root() + path, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ ...body, sections: SECTION, sections_url: location.pathname }) });
      const data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || 'Error');
      if (data.sections && data.sections[SECTION]) renderDrawer(data.sections[SECTION]); else await refreshDrawer();
      return data;
    } finally { const d2 = drawer(); d2 && d2.classList.remove('is-busy'); }
  }
  async function refreshDrawer() {
    const res = await fetch(root() + '?sections=' + SECTION);
    renderDrawer((await res.json())[SECTION]);
  }
  function renderDrawer(html) {
    const tmp = document.createElement('div'); tmp.innerHTML = html;
    const fresh = $('#TbCartDrawer', tmp), cur = drawer();
    if (!fresh || !cur) return;
    const open = cur.classList.contains('is-open');
    cur.replaceWith(fresh); if (open) fresh.classList.add('is-open');
    paintDates(); tick();
    document.dispatchEvent(new CustomEvent('klivlo:cart-updated', { detail: { count: fresh.dataset.count } }));
  }
  const openDrawer = () => { const d = drawer(); if (!d) return; d.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; };
  const closeDrawer = () => { const d = drawer(); if (!d) return; d.classList.remove('is-open'); document.documentElement.style.overflow = ''; };
  window.TbCart = { open: openDrawer, close: closeDrawer, refresh: refreshDrawer };

  document.addEventListener('click', async e => {
    const t = e.target;
    if (t.closest('[data-tb-close]')) { e.preventDefault(); closeDrawer(); return; }
    const cartLink = t.closest('a[href$="/cart"], [data-tb-open-cart], #cart-icon-bubble');
    if (cartLink && drawer() && !t.closest('#TbCartDrawer')) { e.preventDefault(); openDrawer(); return; }
    const upd = t.closest('[data-tb-update]');
    if (upd) { e.preventDefault(); await cartPost('cart/update.js', { updates: JSON.parse(upd.dataset.tbUpdate) }); return; }
    const up = t.closest('[data-tb-upgrade]');
    if (up) {
      e.preventDefault();
      // Swap the single bag for a Buy 2 (same colour + the default second colour); the automatic discount applies at 2+
      const bid = 'b' + Date.now().toString(36);
      await fetch(root() + 'cart/update.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ updates: { [up.dataset.key]: 0 } }) });
      await cartPost('cart/add.js', { items: bundleItems(+up.dataset.a, +up.dataset.b, bid) });
      return;
    }
    const anchor = t.closest('a[href="#MainProduct"]');
    if (anchor) { const el = document.getElementById('MainProduct'); if (el) { e.preventDefault(); el.scrollIntoView({ behavior: 'smooth' }); } }
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeDrawer(); });

  function bundleItems(a, b, bid) {
    return a === b ? [{ id: a, quantity: 2, properties: { _tb_bundle: bid } }]
      : [{ id: a, quantity: 1, properties: { _tb_bundle: bid } }, { id: b, quantity: 1, properties: { _tb_bundle: bid } }];
  }

  // ---------- Product ----------
  function initProduct(sec) {
    if (sec.dataset.tbReady) return; sec.dataset.tbReady = '1';
    const V = cfg.variants || [];
    let bundle = cfg.defaultBundle || 2, c1 = 0, c2 = Math.min(cfg.c2 ?? 2, V.length - 1), img = 0;
    const slides = $$('[data-tb-slide]', sec), thumbs = $$('[data-tb-thumb]', sec);
    const heroImg = $('[data-tb-hero]', sec), heroThumb = $('[data-tb-hero-thumb]', sec), stickyImg = $('[data-tb-sticky-img]', sec);
    const atcs = $$('[data-tb-atc]', sec), sticky = $('[data-tb-sticky]', sec), summary = $('[data-tb-summary]', sec);

    const showImg = i => { img = (i + slides.length) % slides.length; slides.forEach((s, k) => s.classList.toggle('is-active', k === img)); thumbs.forEach((b, k) => b.classList.toggle('is-active', k === img)); };
    function render() {
      $$('[data-tb-bundle]', sec).forEach(b => { const on = +b.dataset.tbBundle === bundle; b.classList.toggle('is-active', on); b.setAttribute('aria-checked', on); });
      $$('[data-tb-pick]', sec).forEach(p => { const cur = p.dataset.tbPick === '1' ? c1 : c2; $$('[data-tb-swatch]', p).forEach(s => s.classList.toggle('is-active', +s.dataset.tbSwatch === cur)); });
      $$('[data-tb-name="1"]', sec).forEach(n => (n.textContent = V[c1] ? V[c1].name : ''));
      $$('[data-tb-name="2"]', sec).forEach(n => (n.textContent = V[c2] ? V[c2].name : ''));
      atcs.forEach(b => (b.textContent = bundle === 1 ? cfg.atc1 : cfg.atc2));
      if (summary) summary.textContent = bundle === 1 ? `${cfg.buy1} · ${V[c1].name}` : `${cfg.buy2} · ${V[c1].name} + ${V[c2].name}`;
    }
    function setHero(i) {
      const v = V[i]; if (!v) return;
      if (heroImg) { heroImg.src = v.img; heroImg.removeAttribute('srcset'); }
      if (heroThumb) heroThumb.src = v.thumb;
      if (stickyImg) stickyImg.src = v.thumb;
      showImg(0);
    }

    $$('[data-tb-bundle]', sec).forEach(b => {
      b.addEventListener('click', e => { if (e.target.closest('[data-tb-swatch]')) return; bundle = +b.dataset.tbBundle; render(); });
      b.addEventListener('keydown', e => { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); bundle = +b.dataset.tbBundle; render(); } });
    });
    $$('[data-tb-swatch]', sec).forEach(s => s.addEventListener('click', e => {
      e.stopPropagation();
      const pick = s.closest('[data-tb-pick]').dataset.tbPick, i = +s.dataset.tbSwatch;
      if (pick === '1') c1 = i; else c2 = i;
      bundle = +s.closest('[data-tb-bundle]').dataset.tbBundle;
      setHero(i); render();
    }));
    $('[data-tb-prev]', sec)?.addEventListener('click', () => showImg(img - 1));
    $('[data-tb-next]', sec)?.addEventListener('click', () => showImg(img + 1));
    thumbs.forEach(b => b.addEventListener('click', () => showImg(+b.dataset.tbThumb)));

    atcs.forEach(b => b.addEventListener('click', async () => {
      atcs.forEach(x => (x.disabled = true));
      try {
        const items = bundle === 1 ? [{ id: V[c1].id, quantity: 1 }] : bundleItems(V[c1].id, V[c2].id, 'b' + Date.now().toString(36));
        startReservation();
        await cartPost('cart/add.js', { items });
        openDrawer();
      } catch (err) { alert(err.message); } finally { atcs.forEach(x => (x.disabled = false)); }
    }));

    // Sticky bar: visible once the main button has scrolled above the viewport
    const mainAtc = atcs[0];
    if (sticky && mainAtc && 'IntersectionObserver' in window) {
      new IntersectionObserver(([en]) => {
        const show = !en.isIntersecting && en.boundingClientRect.top < 0;
        sticky.classList.toggle('is-visible', show); sticky.setAttribute('aria-hidden', !show);
      }).observe(mainAtc);
    }
    setHero(c1); render();
  }

  function initPacking(sec) {
    $$('[data-tb-tab]', sec).forEach(t => t.addEventListener('click', () => {
      $$('[data-tb-tab]', sec).forEach(x => x.classList.toggle('is-active', x === t));
      $$('[data-tb-trip]', sec).forEach(x => x.classList.toggle('is-active', x.dataset.tbTrip === t.dataset.tbTab));
    }));
  }

  const boot = () => {
    $$('[data-tb-product]').forEach(initProduct);
    $$('[data-tb-pack]').forEach(initPacking);
    paintDates(); tick();
  };
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', boot) : boot();
  setInterval(tick, 1000);
})();
